// Add the all the panels in the order that they need to appear
// Use suspense and error boundary of rect
// Use webpack chunks and react lazy loading
// Have loader for each panel and initate it here
// Decide between if the panel needs to be a displayed on logIn or logged out

import React, { Suspense } from 'react';
import ErrorBoundary from '../../../shared/ErrorBoundary';
import TopicTreeIntentsPanel from '../panels/TopicTreeIntentsPanel';
import { pageNames } from '../../../common/constants';
import HeroPanel from '../panels/HeroPanel';
import {
  callUsFPTIs,
  chatBotFPTIs,
  contactOptionsFPTIs,
  heroFPTIs,
  topicTreeIntentsFPTIs,
} from '../../../helpers/analytics/contactUsPageAnalytics';
import ContactOptionsPanel from '../panels/ContactOptionsPanel';
import CallUsInfoPanel from '../panels/CallUsInfoPanel';
import ChatbotPanel from '../panels/ChatbotPanel';
import ModalContainer from '../../../../js/contactUs/containers/ModalContainer';
// const TopicTreeIntentsPanel = React.lazy(() =>  import(/* webpackChunkName: "TopicTreeIntentsPanel.sh.chunk" */ '../panels/TopicTreeIntentsPanel'));
// const HeroPanel = React.lazy(() => import (/* webpackChunkName: "HeroPanel.sh.chunk" */ '../panels/HeroPanel') )

const ContactUsPage = function () {
  const defaultLayout = () => (
    <div>
      <Suspense fallback={<div className="home-loader-container" />}>
        <div className="sh_contact_us_hero_and_topic_intent_panel">
          <ErrorBoundary>
            <HeroPanel FPTIData={heroFPTIs} pageName={pageNames.CONTACT_US} />
          </ErrorBoundary>
          <ErrorBoundary errorFPTI={topicTreeIntentsFPTIs.topicTreeIntentsError}>
            <TopicTreeIntentsPanel pageName={pageNames.CONTACT_US} FPTIData={topicTreeIntentsFPTIs} />
          </ErrorBoundary>
        </div>

        <ErrorBoundary>
          <ContactOptionsPanel pageName={pageNames.CONTACT_US} FPTIData={contactOptionsFPTIs} />
        </ErrorBoundary>

        <ErrorBoundary>
          <ChatbotPanel pageName={pageNames.CONTACT_US} FPTIData={chatBotFPTIs} />
        </ErrorBoundary>

        <ErrorBoundary>
          <CallUsInfoPanel pageName={pageNames.CALL_US} FPTIData={callUsFPTIs} />
        </ErrorBoundary>

        <ErrorBoundary>
          <ModalContainer />
        </ErrorBoundary>
      </Suspense>
    </div>
  );
  return defaultLayout();
};

export default ContactUsPage;
